<template>
  <b-row>
    <a :href="'#'+$route.path"><b-icon icon="plus-circle" variant="primary" font-scale="2.5" v-b-popover.hover.left="'Add new Address'" @click="postAddress()"></b-icon></a>
    <b-col cols="6"><b-form-input v-model="newaddress" placeholder="New Address"></b-form-input></b-col>
    <b-col cols="3"><b-form-select v-model="newaddrtype" :options="addresstypes"></b-form-select></b-col>
  </b-row>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'AddAddress',
  props: ['vendor_id'],
  data() {
    return {
      newaddress: '',
      newaddrtype: 0,
      addresstypes: [
        { value: 0, text: 'Select an address type', disabled: true },
        { value: 1, text: 'Mailing address' },
        { value: 2, text: 'Billing address' },
        { value: 3, text: 'Delivery address' },
        { value: 4, text: 'Email address' },
        { value: 5, text: 'Mobile phone' },
        { value: 6, text: 'Landline' },
        { value: 7, text: 'Fax' },
        { value: 8, text: 'Website' },
        { value: 9, text: 'Facebook' },
        { value: 10, text: 'Twitter' },
        { value: 11, text: 'Instagram' }
      ]
    }
  },
  methods: {
    emitSwitchOverlay(bool) {
      this.$emit('emit-switch-overlay', bool);
    },

    emitUpdateEntity(address_id) {
      this.$emit('emit-update-entity', address_id);
    },

    async postAddress() {
      this.emitSwitchOverlay(true);
      if (this.newaddress == '' || this.newaddrtype == 0) {
        alert('Please complete both address fields!');
      }
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      var body = {
        "address": this.newaddress,
        "address_type_id": this.newaddrtype
      }
      // update order with status of 'ready'
      const { data } = await this.$api.post('vendor/'+this.vendor_id+'/addresses',
        body,
        config
      );
      if (data.created == true) {
        this.emitUpdateEntity(data.new_addr_id);
        this.newaddress=''; this.newaddrtype=0;
      } else {
        this.emitSwitchOverlay(false);
        this.$bvModal.msgBoxOk('There was a problem adding the address, please try again later.', {
          title: 'Error adding address',
          centered: true
        })
      }
    },

  }
}
</script>
<style></style>
